const config = {
  api: {
      baseURL: window.API_URL,
      timeout: 60000,
  },
  imageServer: window.IMG_URL, // 图片服务器路径
};

export default config;